export default "/static/334da737f892b360c0f8a4994f29cfcf844caefd/frontend/1c2dc0f32895d26aac4476663547b9b3.svg";